module.exports = __webpack_public_path__ + "static/fonts/PingFang_Bold.dd25b35.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/css/PingFang_Bold.ttf
// module id = 3Iia
// module chunks = 1